import React from 'react';
import '../../styles/about.css';

const About = () => {
	return (
		<div className='hero-img tab'>
			<div className='hero-txt'>
				<div className='intro'>
					<p className='typewriter'>Hi, I'm Brigitte</p>
					<p className='type-cursor animate__animated animate__repeat-3 animate__fadeOut'>
						|
					</p>
				</div>
				<p>
					<span>
						I'm a <strong>designer and developer</strong> currently
						based in <strong>Helotes, TX</strong>. I'm passionate
						about responsive design, functional{' '}
						<strong>JavaScript</strong>, and organizing clutter.
						<br />
						<br />
						As a technical writing major, I've come to find there's
						nothing more important than effective communication. To
						that end, I'm always seeking to learn the newest
						technologies and methods that we use to share knowledge
						everyday.
						<br />
						<br />
						I'm a proud graduate from the University of Texas at San
						Antonio (go roadrunners!) with an undergraduate in
						Technical Writing and a hobbyist graphic designer,
						writer, and programmer. It is my goal to use my
						well-rounded database of skills to create content that{' '}
						<strong>educates and helps people</strong> come together
						to learn and grow.
					</span>
				</p>
			</div>
		</div>
	);
};

export default About;
